"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _MeterReadingEmailFeedbackPropTypes = require("./MeterReadingEmailFeedbackPropTypes");
var MeterReadingMailboxInfoPopup = function MeterReadingMailboxInfoPopup(props) {
  var _props$closeButton, _props$closeButton2;
  return /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.PopUp, {
    id: "meter-reading-mailbox-info-popup",
    size: "custom-size",
    userOnClose: function userOnClose() {
      props.onClose();
    },
    overlayOnClose: false,
    show: !!props.showPopup
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row meter-reading-mailbox-info__container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-offset-1 col-xs-10"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "meter-reading-mailbox-info__headline",
    id: "meter-reading-mailbox-info-popup-label"
  }, props.headline), /*#__PURE__*/_react.default.createElement("p", {
    className: "meter-reading-mailbox-info__subline"
  }, props.subline, /*#__PURE__*/_react.default.createElement("span", {
    className: "meter-reading-mailbox-info__email"
  }, props.email)), /*#__PURE__*/_react.default.createElement("p", {
    className: "meter-reading-mailbox-info__description",
    id: "meter-reading-mailbox-info-popup-described"
  }, props.description), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-mailbox-info__buttons"
  }, ' ', /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Button, {
    version: (_props$closeButton = props.closeButton) === null || _props$closeButton === void 0 ? void 0 : _props$closeButton.version,
    id: "meter-reading-mailbox-info_close-button",
    qaId: "meter-reading-mailbox-info_close-button",
    onClick: function onClick() {
      document.getElementsByTagName('html')[0].classList.remove('prevent-scroll');
      document.getElementsByTagName('html')[0].removeAttribute('style');
      props.onClose();
    }
  }, (_props$closeButton2 = props.closeButton) === null || _props$closeButton2 === void 0 ? void 0 : _props$closeButton2.label)))));
};
MeterReadingMailboxInfoPopup.propTypes = _MeterReadingEmailFeedbackPropTypes.meterReadingMailboxInfoPopupPropTypes;
var _default = exports.default = MeterReadingMailboxInfoPopup;